var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeal = function SvgMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 6.5,
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 3.5,
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.93 8.09c.18 1.6.02 3.21.08 4.81.02.43-.23 1.1.48 1.1s.47-.68.47-1.1c.02-3.64.01-7.28 0-10.92 0-.32.1-.67-.18-.98-.86.24-1.5.88-1.62 1.76a22.08 22.08 0 0 0-.04 4.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.93 8.09c.18 1.6.02 3.21.08 4.81.02.43-.23 1.1.48 1.1s.47-.68.47-1.1c.02-3.64.01-7.28 0-10.92 0-.32.1-.67-.18-.98-.86.24-1.5.88-1.62 1.76a22.08 22.08 0 0 0-.04 4.99l.8.34ZM1.17 1.17c.19 1.2.05 2.4.08 3.59.01.46-.01.94.44 1.18.41.22.8.5.8.83L2.5 14M3.99 1.17c0 1.03-.05 2.05.01 3.08.05.83-.18 1.48-.87 1.96M2.55 1.17V4.6",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgMeal;